import React from 'react';
import BusIcon from '../../../assets/bus-icon';
import useDetectIsMobile from '../../../hook/use-detect-is-mobile';

const RouteItemMobile = ({ no, origin, destination, cost, onNavigate }) => {
  return (
    <div
      className="flex justify-between items-center py-5 px-4 bg-white border border-gray-300 rounded-lg cursor-pointer"
      onClick={onNavigate}
    >
      <div className="flex sm:w-[25%] justify-center">
        <span className="bg-[#055C79] text-white h-[30px] w-[30px] text-center items-center justify-center flex text-xl font-bold rounded-full">
          {no}
        </span>
      </div>
      <div className="flex w-[75%] flex-col justify-center items-start gap-2">
        <div className="flex justify-center items-center gap-6">
          <div className="flex flex-col items-start">
            <span className="text-sm md:text-base text-[#757575] text-left">Dari</span>
            <span className="text-base md:text-xl font-bold text-left">{origin}</span>
          </div>
        </div>
        <div className="flex flex-col justify-center items-start gap-2 border-black">
          <div className="flex flex-col items-start">
            <span className="text-sm md:text-base text-[#757575] text-left md:text-right">Ke</span>
            <span className="text-base md:text-xl font-bold text-left md:text-right">
              {destination}
            </span>
          </div>
          <div className="hidden">|</div>
          <div className="flex flex-col">
            <span className="text-[12px] md:text-sm text-[#757575] text-left">Rata-rata Tarif</span>
            <span className="text-base md:text-xl text-primary-500 font-bold text-left">
              {cost}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const RouteItemWeb = ({ no, origin, destination, cost, onNavigate }) => {
  return (
    <div
      className="flex flex-1 justify-between items-center py-5 px-5 bg-white shadow-md rounded gap-6 cursor-pointer"
      onClick={onNavigate}
    >
      <div className="flex justify-center items-center gap-6">
        <span className="bg-[#055C79] flex justify-center items-center text-white h-[30px] w-[30px] rounded-full text-center text-xl font-bold">
          {no}
        </span>
        <div className="flex flex-col items-start">
          <span className="text-left text-base text-[#757575]">Dari</span>
          <span className="text-left text-xl font-bold">{origin}</span>
        </div>
      </div>
      <div className="flex items-center justify-center">
        <hr className="w-20 hidden lg:inline h-px my-8 bg-[#0AB7F1] border-0" />
        <div className="mx-4">
          <BusIcon />
        </div>
        <hr className="w-20 hidden lg:inline h-px my-8 bg-[#0AB7F1] border-0" />
      </div>
      <div className="flex justify-center items-center gap-6 border-black">
        <div className="flex flex-1 flex-col items-end">
          <span className="text-right text-base text-[#757575]">Ke</span>
          <span className="text-right text-xl font-bold">{destination}</span>
        </div>
        <div className="flex">|</div>
        <div className="flex flex-col items-center">
          <span className="text-center text-sm text-[#757575]">Rata-rata Tarif</span>
          <span className="text-center text-xl text-primary-500 font-bold">{cost}</span>
        </div>
      </div>
    </div>
  );
};

const OriginDestinationItem = (props) => {
  const { isTablet, isMobile } = useDetectIsMobile();
  return isTablet || isMobile ? <RouteItemMobile {...props} /> : <RouteItemWeb {...props} />;
};

export default OriginDestinationItem;
